import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { Region } from '@/types/domain'

export const useRegionStore = defineStore('region', () => {
  const regions = ref<Region[]>([])
  const region = ref(localStorage.getItem('region') ?? '')
  const regionLocked = ref(false)

  const currentRegion = computed(() => region.value)

  async function loadRegions() {
    const { api } = await import('@/services')
    const result = await api.getRegions()
    regions.value = result
    if (!region.value) {
      const storedRegion = localStorage.getItem('region')
      if (storedRegion) {
        region.value = storedRegion
      } else if (result.length > 0) {
        region.value = result[0].name
      }
    }
  }

  function changeRegion(newRegion: string) {
    region.value = newRegion
    localStorage.setItem('region', newRegion)
  }

  function lockRegion() {
    regionLocked.value = true
  }

  function unlockRegion() {
    regionLocked.value = false
  }

  function $reset() {
    regions.value = []
    region.value = ''
    regionLocked.value = false
  }

  return {
    regions,
    region,
    regionLocked,
    currentRegion,
    loadRegions,
    changeRegion,
    lockRegion,
    unlockRegion,
    $reset,
  }
})
